import { KazooError } from "@kazoohr/types";
import { AssertionErrorFactory } from "./assertionErrorFactory";

export function assertIsNotUndefined<T>(
  parameter: T | undefined,
  errorFactory: AssertionErrorFactory<T> = () => {
    return new KazooError(
      "Expected a value for assertIsNotUndefined(). 'undefined' provided."
    );
  }
): asserts parameter is T {
  if (parameter === undefined) {
    throw errorFactory(parameter);
  }
}
